import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=24065bbc&"
import script from "./the-footer.js?vue&type=script&lang=js&"
export * from "./the-footer.js?vue&type=script&lang=js&"
import style0 from "./the-footer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports